import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from '@material-ui/core';
import { ArrowBack, ArrowForward } from '@material-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import KenSelect from '../../../../global_components/KenSelect/index';
import './roomAvailability.css';

const selectOptionsSpace = [
  {
    label: '0',
    value: '0',
  },
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
];

function RoomAvailablity({
  setEligible,
  roomChoosen,
  setRoomChoosen,
  numStudents,
  setNumStudents,
  selectValueSpace,
  setSelectValueSpace,
  facilityData,
  handleRoomDeletion,
  handleRoomAddition,
  roomData,
  edit,
}) {
  const [selectedItemsAvail, setSelectedItemsAvail] = useState([]);
  const [selectedItemsChoosen, setSelectedItemsChoosen] = useState([]);

  useEffect(() => {
    let numStd = 0;
    roomChoosen?.forEach((el) => {
      let seatsAllocated = 0;
      for (let i = 1; i <= Number(el?.seatsPerBench); i++) {
        seatsAllocated++;
        if (Number(selectValueSpace) !== 0) i = Number(selectValueSpace) + i;
      }
      numStd = seatsAllocated * el?.noOfColumns * el?.noOfRows + numStd;
    });
    setNumStudents(numStd);
  }, [roomChoosen, selectValueSpace, setNumStudents]);

  useEffect(() => {
    if (roomChoosen?.length > 0) {
      setEligible(true);
    }
  }, [roomChoosen, setEligible]);

  const selectHandlerAvail = (e) => {
    setSelectedItemsAvail((state) => {
      return { ...state, [e.target.name]: e.target.checked };
    });
  };

  const selectHandlerChoosen = (e) => {
    setSelectedItemsChoosen((state) => {
      return { ...state, [e.target.name]: e.target.checked };
    });
  };

  let selectedValues1 = [];
  for (const key in selectedItemsAvail) {
    if (Object.hasOwnProperty.call(selectedItemsAvail, key)) {
      const element = selectedItemsAvail[key];
      if (element) {
        selectedValues1.push(key);
      }
    }
  }
  const rightArrowHandler = () => {
    if (!selectedValues1) {
      return;
    }

    const roomChoosenArray = roomData?.availableData?.filter((single) => {
      return selectedValues1.includes(single.facilityId);
    });

    const roomAvailableArray = roomData?.availableData?.filter((single) => {
      return !selectedValues1.includes(single.facilityId);
    });

    // setRoomsCapicityData(roomAvailableArray);
    setRoomChoosen((prev) => [...prev, ...roomChoosenArray]);

    setSelectedItemsAvail([]);
    handleRoomAddition(roomChoosenArray);
  };

  let selectedValues = [];
  for (const key in selectedItemsChoosen) {
    if (Object.hasOwnProperty.call(selectedItemsChoosen, key)) {
      const element = selectedItemsChoosen[key];
      if (element) {
        selectedValues.push(key);
      }
    }
  }
  
  const leftArrowHandler = () => {
    if (!selectedValues) {
      return;
    }

    const roomAvailableArray = roomChoosen.filter((single) => {
      return selectedValues.includes(single?.facilityId);
    });

    const roomChoosenArray = roomChoosen.filter((single) => {
      return !selectedValues.includes(single?.facilityId);
    });

    setRoomChoosen(roomChoosenArray);
    // setRoomsCapicityData((prev) => [...prev, ...roomAvailableArray]);

    setSelectedItemsChoosen([]);
    handleRoomDeletion(roomAvailableArray);
  };

  const getAllocatedSeat = (data) => {
    let seatsAllocated = 0;
    for (let i = 1; i <= Number(data?.seatsPerBench); i++) {
      seatsAllocated++;
      if (Number(selectValueSpace) !== 0) i = Number(selectValueSpace) + i;
    }
    return seatsAllocated * data?.noOfColumns * data?.noOfRows;
  };

  // console.log('test123',roomData?.availableData);
  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="baseline"
        style={{ marginBottom: '12px' }}
      >
        <Grid item sm={5} xs={12} className="flex-tabs">
          <div>
            <Typography variant="p" className="typo">
              {/* Eligible Student : {currentSeatingPlanData?.totalEligibleStudents}  */}
              Eligible Student : {roomData?.eligibelStudents}
            </Typography>
            <Typography variant="p" className="typo">
              {/* Number of Students with Seating Plan : {numStudents} */}
              Seat Allocated  : {numStudents}
            </Typography>
          </div>
        </Grid>
        <Grid item sm={2} xs={12}>
          {''}
        </Grid>

        <Grid item sm={5} xs={12} container>
          <Grid xs={8} style={{ display: 'flex', justifyContent: 'flex-end',marginTop:'10px' }}>
            <Typography variant="p" className="typo">
              Inter-Candidate Spacing:
            </Typography>
          </Grid>
          <Grid
            xs={4}
            style={{ display: 'flex', justifyContent: 'flex-start' }}
          >
            <KenSelect
              options={selectOptionsSpace}
              value={selectValueSpace}
              disabled={edit === false ? true : false}
              onChange={(e) => {
                setSelectValueSpace(e.target.value);
              }}
              required={true}
            />
          </Grid>
        </Grid>
      </Grid>
      {/* Items with two table */}
      <Grid item xs={12} sm={12}>
        <div className="seating-box" id="main_container">
          <div id="drag">
            <Grid item xs={12} sm={5}>
              <div id="left">
                <table id="table5">
                  <colgroup>
                    <col width="100%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className="top-header">Room Availiblity</th>
                    </tr>
                    <tr>
                      <th>
                        <div className="flex-space-between">
                          <div>Room </div>
                          <div> Effective Capacity</div>
                        </div>
                      </th>
                    </tr>
                    {roomData?.availableData?.map((single) => {
                      return (
                        <tr key={single.facilityId}>
                          <td>
                            {single?.effectiveCapacity !== null ? (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    className="checkbox-custom"
                                    onChange={selectHandlerAvail}
                                    name={single.facilityId}
                                    value={single.facilityId}
                                  />
                                }
                                label={
                                  <div
                                    id="x"
                                    className={`drag flex-space-between ${
                                      selectedValues1.includes(
                                        single.facilityId
                                      )
                                        ? 'newCss'
                                        : ''
                                    }`}
                                  >
                                    <div>{single?.facilityName}</div>
                                    <div>{single?.effectiveCapacity}</div>
                                  </div>
                                }
                              />
                            ) : null}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Grid>
            <Grid item xs={12} sm={2} className="btn-group">
              <button
                className="custom-btn"
                onClick={() => {
                  edit == true && rightArrowHandler();
                }}
              >
                <ArrowForward />
              </button>
              <button
                className="custom-btn"
                onClick={() => {
                  edit == true && leftArrowHandler();
                }}
              >
                <ArrowBack />
              </button>
            </Grid>
            <Grid item xs={12} sm={5}>
              <div id="right">
                <table id="table6">
                  <colgroup>
                    <col />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className="top-header">Room Choosen</th>
                    </tr>
                    <tr>
                      <th>
                        <div className="flex-space-between">
                          <div>Room </div>
                          <div>Seat Allocated</div>
                        </div>
                      </th>
                    </tr>
                    {roomChoosen?.map((single) => {
                      return (
                        <tr key={single?.facilityId}>
                          <td>
                            {single?.effectiveCapacity ? (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    className="checkbox-custom"
                                    onChange={selectHandlerChoosen}
                                    name={single?.facilityId}
                                    value={single?.facilityId}
                                  />
                                }
                                label={
                                  <div
                                    id="x"
                                    className={`drag flex-space-between ${
                                      selectedValues.includes(
                                        single?.facilityId
                                      )
                                        ? 'newCss'
                                        : ''
                                    }`}
                                  >
                                    <div>{single?.facilityName}</div>
                                    <div>{getAllocatedSeat(single)}</div>
                                  </div>
                                }
                              />
                            ) : null}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Grid>
          </div>
        </div>
      </Grid>
    </>
  );
}

export default RoomAvailablity;
